import { useCallback } from 'react';
import { useMetaTagsContext } from '@/creditflowresearch/application/MetaTags/MetaTagsContext';
import { getMetaTagsByFilters } from '@/creditflowresearch/application/actions/profile/helpers/getMetaTagsByFilters';
import { IIndustry } from '@/creditflowresearch/domain/vo/IDeal';
import { ISector } from '@dm-portal/sector/Sector';

interface IUseSetMetaTagsParams {
  isConsumerOverview?: boolean,
  profileType?: string,
  industry?: IIndustry,
  sector?: ISector,
  pathname: string,
}

export const useSetMetaTags = () => {
  const { setMetaTags } = useMetaTagsContext();

  return useCallback(({
    isConsumerOverview,
    profileType,
    industry,
    sector,
    pathname,
  }: IUseSetMetaTagsParams) => {
    setMetaTags(getMetaTagsByFilters({
      isConsumerOverview,
      profileType,
      industry,
      sector,
      pathname,
    }));
  }, [setMetaTags]);
};
